import { useMemo } from 'react';
import { SolverEngine, useEnabledSolverEnginesQuery } from '../types/planung-graphql-client-defs';
import { useAuthClaims } from './useAuthClaims';
import { useMemorizedCacheTag } from './useMemorizedCacheTag';

// Canonical display order; also used to normalize whatever order the backend stored.
// ASC/Untis sind hier bewusst nicht mehr enthalten — die Offline-Solver wurden abgeschafft.
const ALL_ENGINES: SolverEngine[] = [SolverEngine.Mathplan, SolverEngine.Timefold];

/**
 * Solver engines the current user may select for the current organization: the organization's
 * `enabledSolverEngines` — which now applies to omni-admins too (no more "see every engine"
 * bypass) — with an empty/unconfigured list falling back to Timefold only. Configuring the set
 * itself still happens through SolverInterfaceSettings, so omni-admins can hand engines out there.
 */
export const useAvailableSolverEngines = (): SolverEngine[] => {
  const { pimAuthClaims } = useAuthClaims();
  const context = useMemorizedCacheTag('ORGANIZATION');
  const organizationUuid = pimAuthClaims.getOrganizationUuid();

  const [{ data }] = useEnabledSolverEnginesQuery({
    context,
    pause: !organizationUuid,
  });

  return useMemo(() => {
    const enabled = data?.enabledSolverEngines ?? [];
    const allowed = ALL_ENGINES.filter((engine) => enabled.includes(engine));
    return allowed.length > 0 ? allowed : [SolverEngine.Timefold];
  }, [data]);
};
